import React, { createContext, useState } from 'react';

const GlobalStatusContext = createContext();

export const GlobalStatusProvider = ({ children }) => {
  const [isLoadingLoginStatus, setIsLoadingLoginStatus] = useState(true);
  const [isAlertMsgOpen, setIsAlertMsgOpen] = useState(false);
  const [alertMsgData, setAlertMsgData] = useState({ msg: '' });
  const [currentActiveData, setCurrentActiveData] = useState(false);
  const [entryPath, setEntryPath] = useState('');
  const [locale, setLocale] = useState(navigator.language);
  const [modalName, setModalName] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const [modalData, setModalData] = useState({});

  const handleAlertMsgSettings = (open, msg) => {
    setIsAlertMsgOpen(open);
    if (open) {
      setAlertMsgData(msg);
    } else {
      setAlertMsgData('');
    }
  }

  // console.log("navigator.language", navigator.language);
  // console.log("navigator.languages", navigator.languages);

  return (
    <GlobalStatusContext.Provider
      value={{
        isLoadingLoginStatus,
        setIsLoadingLoginStatus,
        isAlertMsgOpen,
        setIsAlertMsgOpen,
        alertMsgData,
        setAlertMsgData,
        handleAlertMsgSettings,
        currentActiveData,
        setCurrentActiveData,
        entryPath,
        setEntryPath,
        locale,
        setLocale,
        modalName, 
        setModalName,
        isModalOpen,
        setIsModalOpen,
        editMode,
        setEditMode,
        modalContent,
        setModalContent,
        modalData,
        setModalData
      }}
    >
      {children}
    </GlobalStatusContext.Provider>
  )
}

export default GlobalStatusContext;